//显示设置
export const typeRadioList = [
  {label: '0', name: '仅图标'},
  {label: '1', name: '仅名称'},
  {label: '2', name: '图标+名称'},
  {label: '3', name: '图标+检测指标值'},
  {label: '4', name: '检测指标值'},
]
//常显设置
export const displayRadioList = [
  {label: '1', name: '按设备类型'},
  {label: '2', name: '按类型标签'},
  {label: '3', name: '按设备'},
]
